<template>
  <!-- size="40%" -->
  <Modal
    :name="modalName"    
    :close="true"
    :size="'65%'"
    @closeModal="onClose"
  >
    <div class="email-history-modal-content p-3 w-100">
      <h2 class="h5 font-weight-bold text-dark mb-3 email-history-modal-header">
        {{ $t('lang.label.email_history') }}{{ client ? ` – ${client.client_name}` : '' }}
      </h2>

      <div v-if="loading" class="d-flex align-items-center justify-content-center py-5">
        <LoadingSpinner />
      </div>
      <template v-else>
        <div v-if="displayEmails.length === 0" class="text-muted small mb-4">
          {{ $t('lang.label.email_history_empty') }}
        </div>
        <div v-else class="d-flex flex-column mb-2 flex-fill overflow-auto">
          <div
            v-for="(msg, index) in displayEmails"
            :key="emailRowKey(msg, index)"
            class="p-3 border rounded bg-light shadow-sm mb-3 email-bubble"
            :class="msg.msg_type === 'sent' ? 'email-bubble-sent' : 'email-bubble-response'"
          >
            <div class="d-flex align-items-start mb-2">
              <div class="mr-2 email-history-avatar-wrap">
                <div
                  class="rounded bg-light d-flex align-items-center justify-content-center overflow-hidden"
                  style="width: 24px; height: 24px;"
                >
                  <img
                    src="@/assets/images/comment.png"
                    alt=""
                    class="rounded"
                    style="width: 14px; height: 14px; opacity: 0.7;"
                  >
                </div>
              </div>
              <div class="small text-secondary flex-fill min-width-0">
                <div class="d-flex flex-wrap align-items-baseline">
                  <span class="font-weight-bold text-dark mr-1">{{ typeLabel(msg.msg_type) }}</span>
                  <span class="text-muted">· {{ msg.msg_date || '—' }}</span>
                </div>
                <div class="text-dark font-weight-bold mt-1 email-subject">
                  {{ msg.subject || '—' }}
                </div>
                <div class="mt-1 email-meta text-muted">
                  <span v-if="msg.client_name">{{ msg.client_name }}</span>
                  <span v-if="msg.client_name && msg.email"> · </span>
                  <span v-if="msg.email">{{ msg.email }}</span>
                  <template v-if="recipientLine(msg)">
                    <span> · </span>
                    <span>{{ recipientLine(msg) }}</span>
                  </template>
                </div>
              </div>
            </div>
            <div class="email-history-body-wrap">
              <div
                class="email-history-body text-dark"
                v-html="msg.body || ''"
              />
            </div>
          </div>
        </div>
      </template>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";

const DEFAULT_MODAL_NAME = "email-history-modal";

export default {
  name: "EmailHistory",
  components: {
    Modal,
    LoadingSpinner
  },
  props: {
    modalName: {
      type: String,
      default: DEFAULT_MODAL_NAME
    },
    client: {
      type: Object,
      default: null
    },
    emails: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayEmails() {
      return Array.isArray(this.emails) ? this.emails : [];
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.$modal.show(this.modalName);
      } else {
        this.$modal.hide(this.modalName);
      }
    }
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    typeLabel(msgType) {
      if (msgType === "sent") {
        return this.$t("lang.label.email_type_sent");
      }
      if (msgType === "response") {
        return this.$t("lang.label.email_type_response");
      }
      return msgType || "—";
    },
    recipientLine(msg) {
      const name = msg.recipent_name || msg.recipient_name;
      if (!name) {
        return "";
      }
      return `${this.$t("lang.label.to")} ${name}`;
    },
    emailRowKey(msg, index) {
      const d = msg.msg_date || "";
      const s = (msg.subject || "").slice(0, 40);
      return `${index}-${d}-${s}`;
    }
  }
};
</script>

<style scoped>
.email-history-modal-content {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

.email-history-modal-header {
  flex-shrink: 0;
}

.email-history-avatar-wrap {
  flex-shrink: 0;
}

.email-bubble {
  max-width: 85%;
}

.email-bubble-sent {
  align-self: flex-end;
}

.email-bubble-response {
  align-self: flex-start;
}

.email-subject {
  word-break: break-word;
}

.email-meta {
  word-break: break-word;
}

.min-width-0 {
  min-width: 0;
}

.email-history-body-wrap {
  max-height: 45vh;
  overflow: auto;
  margin-top: 0.25rem;
  border-top: 1px solid rgba(0, 0, 0, 0.06);
  padding-top: 0.5rem;
}

.email-history-body {
  font-size: 0.875rem;
  line-height: 1.45;
}

.email-history-body >>> img {
  max-width: 100%;
  height: auto;
}

.email-history-body >>> table {
  max-width: 100%;
}

.email-history-body >>> a {
  word-break: break-word;
}
</style>
